import { __assign } from 'tslib';
import React__default from 'react';
import { dataViewPage, dataViewSize, activeBusinessFiltersState, useTotalCount } from '@keepeek/commons';
import { Skeleton, useTheme, Box, Pagination, PaginationItem } from '@mui/material';
import clsx from 'clsx';
import { useRecoilState, useRecoilValue } from 'recoil';
import { withSuspense } from '../../withSuspense/index.js';
import SizeSelect from './SizeSelect.js';

var Paginate = function (_a) {
    var _b;
    var className = _a.className, _c = _a.id, id = _c === void 0 ? "pagination" : _c, _d = _a.showSize, showSize = _d === void 0 ? false : _d, componentSize = _a.size, totalCountOverride = _a.totalCountOverride, pageOverride = _a.pageOverride, setPageOverride = _a.setPageOverride, sizeOverride = _a.sizeOverride, maxElementsPerPage = _a.maxElementsPerPage, dataViewKey = _a.dataViewKey, sx = _a.sx;
    var maxElementsToReturn = 10000;
    var _e = useRecoilState(dataViewPage(dataViewKey)), page = _e[0], setPage = _e[1];
    var size = useRecoilValue(dataViewSize(dataViewKey));
    var filters = useRecoilValue(activeBusinessFiltersState(dataViewKey)) || null;
    var totalCount = useTotalCount({ key: dataViewKey, filters: filters });
    if (totalCountOverride) {
        totalCount = totalCountOverride;
    }
    if (pageOverride) {
        page = pageOverride;
    }
    if (setPageOverride) {
        setPage = setPageOverride;
    }
    if (sizeOverride) {
        size = sizeOverride;
    }
    var theme = useTheme();
    var showLastButton = totalCount < maxElementsToReturn;
    var count = Math.ceil(totalCount / size);
    var handleChangePage = function (page) {
        // Go to the top
        window.scrollTo({ top: 0, behavior: "smooth" });
        // Set the page
        setPage(page);
    };
    // Show nothing when we have no element
    if (totalCount <= 0) {
        return null;
    }
    // Show the size selector when we have nothing to paginate
    if (totalCount <= size) {
        return (React__default.createElement(Box, { "data-testid": "Paginate", id: id, className: clsx("Paginate", className, componentSize), sx: __assign({ display: "flex", alignItems: "flex-end" }, sx) }, showSize && (React__default.createElement(Box, null,
            React__default.createElement(SizeSelect, { id: id, maxElementsPerPageAdminConf: maxElementsPerPage, dataViewKey: dataViewKey })))));
    }
    function renderItem(item) {
        var limitToDisplayEllipsis = 8;
        if (totalCount >= maxElementsToReturn && item.page === count && page < count - 1) {
            // No display paginationItem for current page if last page and current page not lastest or penultimate page
            if (count > limitToDisplayEllipsis) {
                return null;
            }
            // If total of pages is low, we display ellipsis because all page number are not visible
            return "...";
        }
        return React__default.createElement(PaginationItem, __assign({}, item));
    }
    return (React__default.createElement(Box, { "data-testid": "Paginate", id: id, className: clsx("Paginate", className, componentSize), sx: __assign((_b = { display: "flex", alignItems: "center", gap: "8px" }, _b[theme.breakpoints.down("sm")] = {
            flexDirection: "column",
            paddingBottom: "8px"
        }, _b), sx) },
        React__default.createElement(Pagination, { onChange: function (_, page) { return handleChangePage(page); }, showFirstButton: true, count: count, showLastButton: showLastButton, boundaryCount: 0, page: page, size: componentSize, renderItem: renderItem }),
        showSize && (React__default.createElement(SizeSelect, { id: id, maxElementsPerPageAdminConf: maxElementsPerPage, dataViewKey: dataViewKey }))));
};
var Paginate$1 = withSuspense(Paginate, { LoadingComponent: Skeleton });

export { Paginate$1 as default };
//# sourceMappingURL=index.js.map
